import { useState, useEffect } from "react";
import _ from "lodash";
import { Ratings } from "components/ratings";
import { rateSchool } from "services/school";
import { SchoolsRatingContainer } from "./school-ratings.style";

type RatingDataType = {
   name: string;
   metric: string;
   rating: 0;
};

const ratingsData: RatingDataType[] = [
   {
      name: "Academic Excellence",
      metric: "academic_excellence",
      rating: 0,
   },
   {
      name: "Conducive Learning Enviroment",
      metric: "conducive_learning_environment",
      rating: 0,
   },
   {
      name: "Moral Discipline",
      metric: "moral_discipline",
      rating: 0,
   },
   {
      name: "Quality of Facilities",
      metric: "quality_of_facilities",
      rating: 0,
   },
   {
      name: "Security Measures",
      metric: "security_measures",
      rating: 0,
   },
   {
      name: "Relationship Management",
      metric: "relationship_management",
      rating: 0,
   },
   {
      name: "curriculum",
      metric: "curriculum",
      rating: 0,
   },
];

export const SchoolRatings = ({ schoolId, ratings, name }) => {
   const [isLoading, setIsLoading] = useState(false);
   const [error, setError] = useState("");
   const [mergedRatingData, setMergedRatingData] = useState<RatingDataType[]>([]);

   useEffect(() => {
      const updatedRatings = ratingsData.reduce((acc, elem) => {
         ratings.forEach((el) => {
            if (elem.metric === el.metric) {
               acc.push({ ...elem, ...el } as never);
            }
         });
         return acc;
      }, []);

      const mergedRatings = [...ratingsData, ...updatedRatings];

      const aqq = mergedRatings.filter((el) => {
         return updatedRatings.every((el2: any) => {
            return el.metric !== el2.metric;
         });
      });

      const finalRatings = [...updatedRatings, ...aqq];
      setMergedRatingData(finalRatings);
   }, [ratings]);

   const ratingChanged = async (score: number, metric: string) => {
      try {
         setIsLoading(true);
         await rateSchool(schoolId, {
            metric,
            score: score / 20,
         });
         setError("");
      } catch (err) {
         setError("unable to rate at the moment");
      } finally {
         setIsLoading(false);
      }
   };

   return (
      <SchoolsRatingContainer>
         <h4>
            Rate {name}
            <span>{isLoading && "......"}</span>
            <span style={{ marginLeft: "10px", color: "red" }}>{error}</span>
         </h4>
         <div className="school--rating">
            {mergedRatingData?.map((item: any) => (
               <div key={item.id}>
                  <p className="subject">{item.name}</p>
                  <div className="rating">
                     <Ratings
                        readonly={false}
                        value={item.rating}
                        showToolTip={false}
                        onChange={(d: number) => ratingChanged(+d, item.metric)}
                     />
                  </div>
               </div>
            ))}
         </div>
      </SchoolsRatingContainer>
   );
};
